/* eslint-disable no-unused-vars */
// React
import React from 'react';

// Componants
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import { ADGMImage, CancelApplicationModalV2 } from 'aurora-components';

// Utils
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { useDispatch } from 'react-redux';
import { discardApplication } from 'aurora-composition/modules/application/actions';
// styles
import styles from './styles';

function Footer({
  classes,
  handleNext,
  handleBack,
  goBack,
  activeStep,
  steps,
  loading,
  children,
  lastStepLabel,
  application,
  hideNextIcon,
  disableNextBtn,
  showContractPreviewHandler,
}) {
  const locale = localStorage.getItem('lang');
  const [isOpen, setIsOpen] = React.useState(false);
  const isAr = locale === 'ar';
  const dispatch = useDispatch();
  const WE_ARE_IN_FIRST_STEP = activeStep === 0;

  return (
    <>
      <div
        className={classNames(classes.nextprevBtnholder, isAr && classes.rotateArrow, {
          [classes.nextprevBtnholderWithContractPreview]: typeof showContractPreviewHandler === 'function',
        })}
      >
        {typeof showContractPreviewHandler === 'function' ? (
          <Button
            disabled={typeof goBack !== 'function' && WE_ARE_IN_FIRST_STEP}
            onClick={WE_ARE_IN_FIRST_STEP ? (typeof goBack === 'function' ? goBack : '') : handleBack}
            startIcon={
              <Hidden xsDown>
                <svg width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M15.9999 5.66681V4.33347L1.70326 4.35414L4.5846 1.47147L3.64193 0.528809L0.584596 3.58614C0.209654 3.9612 -0.000976563 4.46981 -0.000976562 5.00014C-0.000976563 5.53047 0.209654 6.03909 0.584596 6.41414L3.64193 9.47147L4.5846 8.52881L1.74326 5.68747L15.9999 5.66681Z'
                    fill='#0088FF'
                  />
                </svg>
              </Hidden>
            }
            className={classes.backButton}
          >
            {keyEmptyCheck('previous')}
          </Button>
        ) : (
          <Button
            className={classes.handleDelete}
            onClick={() => {
              setIsOpen(true);
            }}
          >
            {/* <ADGMImage name='delete-pma.svg' style={{ paddingRight: '10px' }} alt='delete' /> */}
            {keyEmptyCheck('cancel')}
          </Button>
        )}
        <div
          className={classNames({
            [classes.nextprevBtnholderWithContractPreview]: typeof showContractPreviewHandler === 'function',
          })}
        >
          {typeof showContractPreviewHandler === 'function' ? (
            <Button variant='secondary' onClick={showContractPreviewHandler} className={classes.previewButton}>
              <span className={classes.viewIcon}>
                <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M15.8806 7.454C15.2952 6.174 12.9999 2 7.99991 2C2.99991 2 0.704581 6.174 0.119247 7.454C0.040673 7.62553 0 7.81199 0 8.00067C0 8.18934 0.040673 8.3758 0.119247 8.54733C0.704581 9.826 2.99991 14 7.99991 14C12.9999 14 15.2952 9.826 15.8806 8.546C15.959 8.37466 15.9996 8.18843 15.9996 8C15.9996 7.81157 15.959 7.62534 15.8806 7.454ZM7.99991 12.6667C3.79525 12.6667 1.83325 9.08933 1.33325 8.00733C1.83325 6.91067 3.79525 3.33333 7.99991 3.33333C12.1946 3.33333 14.1572 6.89533 14.6666 8C14.1572 9.10467 12.1946 12.6667 7.99991 12.6667Z'
                    fill='#0D2A3A'
                  />
                  <path
                    d='M7.99984 4.66675C7.34057 4.66675 6.6961 4.86224 6.14794 5.22852C5.59977 5.59479 5.17253 6.11538 4.92024 6.72447C4.66795 7.33356 4.60194 8.00378 4.73055 8.65038C4.85917 9.29699 5.17664 9.89093 5.64282 10.3571C6.10899 10.8233 6.70293 11.1407 7.34954 11.2694C7.99614 11.398 8.66636 11.332 9.27545 11.0797C9.88454 10.8274 10.4051 10.4001 10.7714 9.85198C11.1377 9.30382 11.3332 8.65935 11.3332 8.00008C11.3321 7.11635 10.9806 6.26912 10.3557 5.64423C9.7308 5.01934 8.88357 4.66781 7.99984 4.66675ZM7.99984 10.0001C7.60428 10.0001 7.2176 9.88278 6.8887 9.66302C6.5598 9.44326 6.30345 9.1309 6.15208 8.76545C6.0007 8.4 5.9611 7.99786 6.03827 7.6099C6.11544 7.22194 6.30592 6.86557 6.58562 6.58587C6.86533 6.30616 7.2217 6.11568 7.60966 6.03851C7.99762 5.96134 8.39975 6.00095 8.76521 6.15232C9.13066 6.3037 9.44302 6.56004 9.66278 6.88894C9.88254 7.21784 9.99984 7.60452 9.99984 8.00008C9.99984 8.53051 9.78913 9.03922 9.41405 9.4143C9.03898 9.78937 8.53027 10.0001 7.99984 10.0001Z'
                    fill='#0D2A3A'
                  />
                </svg>
              </span>

              <Hidden xsDown>{keyEmptyCheck('preview_lease_contract_pdf')}</Hidden>
              <Hidden smUp>{keyEmptyCheck('preview')}</Hidden>
            </Button>
          ) : (
            !WE_ARE_IN_FIRST_STEP && (
              <Button
                disabled={typeof goBack !== 'function' && WE_ARE_IN_FIRST_STEP}
                onClick={WE_ARE_IN_FIRST_STEP ? (typeof goBack === 'function' ? goBack : '') : handleBack}
                startIcon={
                  <Hidden xsDown>
                    <svg width='24px' height='24px' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'>
                      <path fill='#0088FF' d='M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z' />
                      <path
                        fill='#0088FF'
                        d='m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z'
                      />
                    </svg>
                    {/* <svg width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M15.9999 5.66681V4.33347L1.70326 4.35414L4.5846 1.47147L3.64193 0.528809L0.584596 3.58614C0.209654 3.9612 -0.000976563 4.46981 -0.000976562 5.00014C-0.000976563 5.53047 0.209654 6.03909 0.584596 6.41414L3.64193 9.47147L4.5846 8.52881L1.74326 5.68747L15.9999 5.66681Z'
                        fill='#0088FF'
                      />
                    </svg> */}
                  </Hidden>
                }
                className={classNames(classes.backButton, {
                  [classes.rotateArrow]: isAr,
                })}
              >
                {keyEmptyCheck('previous')}
              </Button>
            )
          )}
          {children}
          <Button
            disabled={loading || disableNextBtn}
            variant='contained'
            {...(hideNextIcon
              ? {}
              : {
                  endIcon: (
                    <Hidden xsDown>
                      <ADGMImage name='NextArrow.png' alt='next-arrow-btn' />
                    </Hidden>
                  ),
                })}
            endIcon={
              !hideNextIcon && (
                <Hidden xsDown>
                  <ADGMImage name='NextArrow.png' alt='next-arrow-btn' />
                </Hidden>
              )
            }
            color='primary'
            onClick={handleNext}
            className={classNames(classes.nextbtn, {
              [classes.rotateArrow]: isAr,
              [classes.disableBtn]: loading || disableNextBtn,
            })}
          >
            {activeStep === steps?.length - 1 ? keyEmptyCheck(lastStepLabel) : keyEmptyCheck('next')}
          </Button>
        </div>
      </div>
      <CancelApplicationModalV2
        open={isOpen}
        onClose={() => setIsOpen(false)}
        cancelApplication={() => {
          setIsOpen(false);
          dispatch(
            discardApplication(
              application?.applicationDetails?.applicationId ?? application?.applicationId,
              application,
              {
                status: application?.applicationDetails?.applicationStatus === 'DRAFT' ? 'DISCARD' : 'CANCEL',
              },
            ),
          );
        }}
      />
    </>
  );
}

export default withStyles(styles)(Footer);

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  children: PropTypes.node,
  application: PropTypes.object.isRequired,
  showContractPreviewHandler: PropTypes.func,
  lastStepLabel: PropTypes.string,
  hideNextIcon: PropTypes.bool,
  disableNextBtn: PropTypes.bool,
  goBack: PropTypes.func,
};

Footer.defaultProps = {
  showContractPreviewHandler: null,
  children: null,
  lastStepLabel: 'submit',
  hideNextIcon: false,
  disableNextBtn: false,
  goBack: null,
};
